// App.js
import React from 'react';
import Navbar from './components/Navbar';
import Hero  from './components/Home';
import About from './components/About';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';
import SmoothScroll from './components/SmoothScroll.';
import Members from './components/members';
import Gallery from './components/Gallery';

function App() {
  

  return (
    
    <SmoothScroll>
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Members />
      <Gallery />
      <Contact />
      <Footer />
    </SmoothScroll>
    
       
    
     

  );
}

export default App;
